export const profile = {
  name: "Daryle Urrea",
  role: "Software Engineer",
  location: "Software engineer in EdTech",
  email: "daryle.urrea@hotmail.com",
  linkedin: "https://www.linkedin.com/in/daryle-u-3519a0119/",
  headline: "Dependable product systems.",
  summary:
    "Engineering work across .NET backend services, React product UI, cloud infrastructure, and data workflows. AI-assisted planning, review, and documentation help move delivery faster while keeping quality in focus.",
  about:
    "A practice shaped by product engineering, EdTech, security-minded development, and design judgment. The work favors systems that are clear, scalable, durable, and genuinely useful for the people depending on them. Outside the day-to-day, time goes into hobby projects, helping others learn to code, and life with family and dogs.",
};

export const credibility = [
  { value: ".NET", label: "ASP.NET, C#, EF Core" },
  { value: "React", label: "TypeScript UI engineering" },
  { value: "Cloud", label: "AWS, CI/CD, GitHub Actions" },
  { value: "AI", label: "Faster planning, review, and documentation" },
];

export const experience = [
  {
    role: "Software Engineer",
    company: "Cardonex Inc.",
    period: "Jul 2024 - Present",
    focus: ".NET microservices, Web APIs, React.js product UI, Cube and Dagster data workflows, and AI-assisted engineering for faster delivery with stronger quality control.",
  },
  {
    role: "Jr. Developer",
    company: "Education Advanced",
    period: "May 2022 - Jul 2024",
    focus: "ASP.NET, Blazor, Vue, .NET Framework, C#, product maintenance, feature delivery, and team documentation.",
  },
  {
    role: "Chief Electrician",
    company: "U.S. Navy",
    period: "May 2000 - Aug 2020",
    focus: "Technical operations, troubleshooting, leadership, documentation, and mission-critical reliability.",
  },
];

export const skillGroups = [
  {
    title: "Backend",
    summary: "Backend services, relational data, cloud infrastructure, and product APIs.",
    primary: ["C#", ".NET", "ASP.NET", "Web API", "Microservices", "EF Core", "PostgreSQL"],
    secondary: ["AWS", "RDS", "Redis", "API design"],
  },
  {
    title: "Frontend",
    summary: "Product UI built with modern React tooling and earlier experience across Blazor and Vue.",
    primary: ["React.js", "TypeScript", "Vite"],
    secondary: ["Blazor", "Vue", "LESS", "Ant Design", "Kosmos UI"],
  },
  {
    title: "Engineering",
    summary: "Delivery discipline, shared context, and maintainable decisions.",
    primary: ["Design patterns", "Documentation", "Jira", "Confluence"],
    secondary: ["Scrum", "Kanban", "Waterfall"],
  },
  {
    title: "Data, DevOps & AI",
    summary: "Data workflows, deployment automation, infrastructure, and AI-accelerated engineering.",
    primary: ["Redshift", "Dagster", "Cube", "AWS", "CI/CD"],
    secondary: ["GitHub Actions", "Docker", "Terraform", "Grafana", "Flagger", "Codex", "Claude", "AI planning", "AI code review", "AI documentation"],
  },
];

export const education = [
  {
    year: "2022",
    degree: "Master of Science in Information Technology, Software Engineering",
    school: "University of Maryland Global Campus",
  },
  {
    year: "2019",
    degree: "Bachelor of Science in Information Technology, Software Development and Security",
    school: "University of Maryland Global Campus",
    distinction: "Summa Cum Laude",
  },
  {
    year: "2012",
    degree: "Associate of Science in Graphic Design",
    school: "The Art Institute of Pittsburgh",
  },
];

export const credentials = [
  {
    year: "2022",
    name: "AWS Certified Cloud Practitioner",
    note: "Earned credential",
  },
];
